import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { GlobalStyle } from "./style";
import { FullScreenLoading } from "../../components/loading";
import ResponsiveFix from "../../components/responsiveFix";
import { withRouter } from "react-router-dom";
import { SubItemsSharedAction } from "../../actions";
import { Modal } from "../../components/modal";
import {
  CONFIRM_ACCEPT_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT
} from "../../constants/otherTexts";
import { ACCOUNT_TITLE_SUMMARY } from "../../constants/urls";
import { ACCOUNT_TITLE_ICON } from "../../constants/icons";
import { TEAM_PERMISSIONS } from "../../constants/teamManagement";

const AccountTitleSummaryForm = React.lazy(() =>
  import("../../containers/tools/accountTitle/formSummary")
);

class Index extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    const { route } = props;
    let modalComponent, modalIcon, addPermission, itemName, showModal;
    if (route.location.pathname.indexOf(ACCOUNT_TITLE_SUMMARY) !== -1) {
      showModal = true;
      modalComponent = <AccountTitleSummaryForm closeModal={this.closeModal} />;
      modalIcon = `icon ${ACCOUNT_TITLE_ICON}`;
      addPermission = TEAM_PERMISSIONS(true).ACCOUNT_TITLE;
      itemName = "سرفصل‌حساب";
    } else {
      showModal = false;
    }

    this.state = {
      showModal: showModal,
      modalIcon: modalIcon,
      addPermission: addPermission,
      itemName: itemName,
      modalComponent: modalComponent
    };
  }

  closeModal() {
    this.props.toggleSubItemsModal({ show: false, data: null });
  }

  render() {
    const { showModal, modalComponent, modalIcon, modalSvgIcon } = this.state;
    const { Component, route, subItemsModalInfo } = this.props;
    return (
      <ResponsiveFix>
        <GlobalStyle />
        <Suspense fallback={<FullScreenLoading />}>
          <Component route={route} />
        </Suspense>
        {showModal && subItemsModalInfo.show && (
          <Modal
            show={subItemsModalInfo.show}
            icon={modalIcon}
            closeHandler={this.closeModal}
            width="330px"
            loading={subItemsModalInfo.loading}
            header={{
              title: "",
              icon: modalIcon,
              SvgIcon: modalSvgIcon,
              iconColor: "primary_vivid"
            }}
            footer={{
              buttons: [
                {
                  buttonType: "primary",
                  buttonText: CONFIRM_ACCEPT_BUTTON_TEXT,
                  form: "projectSubItemForm",
                  type: "submit",
                  useLoading: true
                },
                {
                  buttonType: "secondary",
                  clickHandler: this.closeModal,
                  buttonText: CONFIRM_REJECT_BUTTON_TEXT
                }
              ]
            }}
          >
            <Suspense fallback={<FullScreenLoading />}>
              {modalComponent}
            </Suspense>
          </Modal>
        )}
      </ResponsiveFix>
    );
  }
}

const mapStateToProps = store => {
  return {
    subItemsModalInfo: store.SubItemsShared.addModalInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleSubItemsModal: info =>
      dispatch(SubItemsSharedAction.setAddModalInfo(info))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Index)
);
